import { Pipe, PipeTransform } from '@angular/core';
import HoldingStatus from '../enums/HoldingStatus.enum';

@Pipe({
  name: 'holdingStatusArrayToString'
})
export class HoldingStatusArrayToStringPipe implements PipeTransform {

  transform(value: HoldingStatus[], statusesLabels?: any[]): string {
    const statusesLabelsObj = statusesLabels?.reduce((acc,value) => ({...acc, [value.value] : value.label}),{});
    const toStringedArrayItems = value.map(el => statusesLabelsObj && statusesLabelsObj[el] ? statusesLabelsObj[el] : HoldingStatus.toString(el)).filter(el => !!el);
    return toStringedArrayItems.join(', ');
  }

}
